import Service from "../../services";

// initial state
const state = {
  industries: [],
};

// getters
const getters = {};

// actions
const actions = {
  async populateIndustries({ commit }) {
    const industries = await Service.industry.getIndustries();
    commit("setIndustries", industries);
    return industries;
  },
};

// mutations
const mutations = {
  setIndustries(state, industries) {
    state.industries = industries;
    console.log("state.industries", state.industries);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
